import { PureComponent, MouseEvent } from 'react';

import { FormattedMessage } from 'react-intl';

import ButtonGroup from '@atlaskit/button/button-group';
import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import { commonMessages } from 'src/i18n';

import { FileEditorMode } from '../types';

import { FileEditorModeChangeEvent } from './file';
import messages from './file-editor-footer.i18n';
import * as styles from './file-editor-footer.style';

type Props = {
  canPreview?: boolean;
  fileEditorMode: FileEditorMode;
  hasUnsavedChanges?: boolean;
  onCancel?: (e: MouseEvent<HTMLElement>) => void;
  onChangeFileEditorMode: (e: FileEditorModeChangeEvent) => void;
  onCommit?: () => void;
};

export default class FileEditorFooter extends PureComponent<Props> {
  static defaultProps = {
    canPreview: false,
    /* eslint react/default-props-match-prop-types: "warn" */
    fileEditorMode: 'editor',
    hasUnsavedChanges: false,
    onCancel: () => {},
    onChangeFileEditorMode: () => {},
    onCommit: () => {},
  };

  handleViewEditor = (e: MouseEvent<HTMLElement>) => {
    this.props.onChangeFileEditorMode({ event: e, fileEditorMode: 'editor' });
  };

  handleViewPreview = (e: MouseEvent<HTMLElement>) => {
    this.props.onChangeFileEditorMode({
      event: e,
      fileEditorMode: 'editor-preview',
    });
  };

  handleViewDiff = (e: MouseEvent<HTMLElement>) => {
    this.props.onChangeFileEditorMode({
      event: e,
      fileEditorMode: 'editor-diff',
    });
  };

  render() {
    const { canPreview, fileEditorMode, hasUnsavedChanges, onCommit } =
      this.props;

    return (
      <styles.Footer>
        <ButtonGroup>
          {fileEditorMode === 'editor' && (
            <CustomThemeButton
              appearance="subtle"
              isDisabled={!hasUnsavedChanges}
              onClick={this.handleViewDiff}
            >
              <FormattedMessage {...messages.viewEditDiff} />
            </CustomThemeButton>
          )}
          {fileEditorMode === 'editor' && canPreview && (
            <CustomThemeButton
              appearance="subtle"
              isDisabled={!hasUnsavedChanges}
              onClick={this.handleViewPreview}
            >
              <FormattedMessage {...messages.preview} />
            </CustomThemeButton>
          )}
          {(fileEditorMode === 'editor-diff' ||
            fileEditorMode === 'editor-preview') && (
            <CustomThemeButton
              appearance="subtle"
              onClick={this.handleViewEditor}
            >
              <FormattedMessage {...messages.edit} />
            </CustomThemeButton>
          )}
          <CustomThemeButton
            appearance="primary"
            isDisabled={!hasUnsavedChanges}
            onClick={onCommit}
          >
            <FormattedMessage {...commonMessages.commit} />
          </CustomThemeButton>
          <CustomThemeButton appearance="subtle" onClick={this.props.onCancel}>
            <FormattedMessage {...commonMessages.cancel} />
          </CustomThemeButton>
        </ButtonGroup>
      </styles.Footer>
    );
  }
}
